import styles from "./MusicSuggestionsCountBadge.module.scss";
import { classNames } from "primereact/utils";

interface IMusicSuggestionsCountBadgeProps {
  count: number;
}

export const MusicSuggestionsCountBadge = ({
  count,
}: IMusicSuggestionsCountBadgeProps) => {
  return (
    <span
      className={classNames(styles.badge, {
        [styles.glowing]: count > 0,
      })}
    >
      ({count})
    </span>
  );
};
